import { BODY_MD_MD_MEDIUM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const BlueBytePointsWrapper = styled.div`
    display: flex;
    height: 36px;
    padding: 6px 16px 6px 14px;
    align-items: center;
    gap: 4px;
    border-radius: var(--border-radius-round, 48px);
    background:
        linear-gradient(254deg, var(--colors-teal-500, #27a3ac) 31.62%, var(--colors-teal-300, #7dc8cd) 97.27%), #7dc8cd;
`;

export const Points = styled.div`
    ${BODY_MD_MD_MEDIUM_STYLES};
    color: var(--colors-text-on-action, #fff);
`;
